module.exports = __webpack_public_path__ + "line.gif";


//////////////////
// WEBPACK FOOTER
// ./~/primeng/resources/images/line.gif
// module id = 160
// module chunks = 24 26